import React from "react";
import "./tooltip_comp.scss";
import { Tooltip } from "antd";

function TooltipComp({ children, placement = "bottom", title = "Tooltip" }) {
  return (
    <Tooltip title={title} placement={placement}>
      {children}
    </Tooltip>
  );
}

export default TooltipComp;
